export default class ClipboardPasteEventHandler {
	#onPasteCb = [];
	#onPasteAsFilesListCb = [];

	/**
	 * @param {Element} element
	 */
	init(element) {
		element.addEventListener('paste', (evt) => {
			evt.preventDefault();
			const clipboardText = (evt.clipboardData || window.clipboardData).getData('text');
			for (const onPasteCallback of this.#onPasteCb)
				onPasteCallback(clipboardText);
			if(this.#onPasteAsFilesListCb.length > 0) {
				const utf8Encode = new TextEncoder();
				const uint8Array = utf8Encode.encode(clipboardText);
				for (const cb of this.#onPasteAsFilesListCb) {
					cb([new Blob([uint8Array])])
				}
			}
		});
	}

	onPaste(cb) {
		this.#onPasteCb.push(cb);
	}

	/**
	 * In case we want to emulate file upload process, usually because it's just one of the ways to upload data - by
	 * pasting it. So the callback has to accept an object that resembles {@link FileList} (it's actually Blobs,
	 * but both can be sent via Fetch API).
	 *
	 * @param {Function} cb
	 */
	onPasteAsFile(cb) {
		this.#onPasteAsFilesListCb.push(cb);
	}
}